




























































import { Component, Vue, Prop } from 'vue-property-decorator';
const SINGLE_SELECT_TYPE = {
  HORIZONTAL: 1,
  VERTICAL: 3,
};
@Component({
  name: 'single-select-item',
})
export default class SingleSelectWidget extends Vue {
  @Prop({ type: Object }) option!: any;
  @Prop({ type: String }) icon?: string;
  @Prop({ type: Boolean, default: false })
  isActive?: boolean;
  @Prop({ type: String, required: true }) label!: string;
  @Prop({ type: String, required: true }) id!: string;
  @Prop({ type: Number, required: true }) value!: number;
  @Prop({ type: Boolean, required: true }) allowCustomValue!: boolean;
  @Prop({ type: Number, default: SINGLE_SELECT_TYPE.HORIZONTAL })
  orientation!: number;

  private get isVertical() {
    return this.orientation === SINGLE_SELECT_TYPE.VERTICAL;
  }

  private get isCustomFont() {
    return this.$store.getters.isVox;
  }

  onClickHandler() {
    if (!this.allowCustomValue) {
      this.$parent.$emit('change', {
        ...this.option,
        allowCustomValue: this.allowCustomValue,
      });
      this.$parent.$emit('toggle-additional-field', {
        allowCustomValue: this.allowCustomValue,
      });
    } else {
      this.$parent.$emit('toggle-additional-field', {
        ...this.option,
        allowCustomValue: this.allowCustomValue,
      });
    }
  }
}
